export const DIVISIONS = ["D1", "D2", "D3", "NAIA", "JUCO", "JC", "JC-CCCAA", "JC-D1", "JC-D2", "JC-D3", "JC-NWAC"];
